import {Component, Input} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {IYii} from '../../../../globals';
import {CommonModule} from '@angular/common';
import {FieldService} from '../../services/FieldService';
import {FormService} from '../../services/FormService';
import {LayoutOptions} from '../../constants/layout-options';
import {Button} from 'primeng/button';
import {InputText} from 'primeng/inputtext';
import {Checkbox} from 'primeng/checkbox';
import {Select} from 'primeng/select';

declare var Yii: IYii;

@Component({
  selector: 'ng-field-dropdown',
  standalone: true,
  imports: [
    FormsModule,
    CommonModule,
    Button,
    InputText,
    Checkbox,
    Select
  ],
  template: `
    <div class="form-row flex-align-center">
      <label></label>
      <div class="flex-row gap-8px flex-align-center">
        <p-checkbox binary="true" [(ngModel)]="field.load_dynamically"/>
        <label>Load data dynamically</label>
      </div>
    </div>

    @if (field.load_dynamically) {
      <div class="form-row">
        <label>Data URL<span class="text-danger">*</span></label>
        <div>
          <input pInputText size="small" type="text" [(ngModel)]="field.data_url" style="width: 100%">
        </div>
      </div>
    }

    @if (!field.load_dynamically) {
      <div class="form-row">
        <label></label>
        <div class="flex-row gap-8px flex-align-center">
          <p-checkbox binary="true" [(ngModel)]="field.calculate_by_additional_val"/>
          <label>{{ Yii.t('app', 'Calculate By Additional Values') }}</label>
        </div>
      </div>
    }

    @if (fieldsvc.ShowAddOptions(field) && !field.load_dynamically) {
      <div class="form-row">
        <label>{{ Yii.t('app', 'Field Options:') }}</label>
        <div>
          @for (option of field.field_options; track option.option_id) {
            <div class="flex-row gap-4px flex-align-center" style="margin-bottom: 4px">
              <span class="text-danger">*</span>
              <input
                type="text"
                pInputText
                size="small"
                [(ngModel)]="option.option_title"
                [placeholder]="(option.option_title) ? option.option_title : 'Option-' + (option.option_id + 1)"
                (change)="fieldsvc.OnFieldChanged.emit(field)"
                style="width: 70%;">
              @if (field.calculate_by_additional_val && (field.field_type === 'radio' || field.field_type === 'dropdown')) {
                <input
                  type="number"
                  pInputText
                  size="small"
                  [(ngModel)]="option.option_additional_value"
                  placeholder="Numeric Val"
                  (change)="fieldsvc.OnFieldChanged.emit(field)"
                  style="width: 10%;"/>
              }
              @if (!option.predefined) {
                <p-button
                  size="small"
                  icon="fa fa-times"
                  [rounded]="true"
                  [text]="true"
                  severity="danger"
                  (click)="fieldsvc.DeleteOption(field, option)"
                />
              }
              <span class="label label-inverse">{{ Yii.t('app', 'Value:') }}{{ option.option_value }}
                ;&nbsp; id= {{ option.option_id }}</span>
            </div>
          }
          <p-button
            (click)="fieldsvc.AddOption(field)"
            [label]="Yii.t('app', 'Add Option')"
            icon="fa fa-plus"
            size="small"
          />
        </div>
      </div>
    }

    @if (field.load_dynamically) {
      <div class="form-row">
        <label></label>
        <div class="flex-row gap-8px flex-align-center">
          <p-checkbox binary="true" [(ngModel)]="field.enable_linked_list"/>
          <label>Link to a value of another field</label>
        </div>
      </div>
    }

    @if (field.enable_linked_list && field.load_dynamically) {
      <div class="form-row flex-align-center">
        <label>Field to link to<span class="text-danger">*</span></label>
        <div>
          <p-select
            [(ngModel)]="field.linked_list"
            [options]="getFieldsToLink()"
            appendTo="body"
            optionLabel="field_title"
            optionValue="field_id"
            />
        </div>
      </div>
    }
  `
})
export class FieldDropdown {
  Yii = Yii;
  @Input() field: any;
  public layouts = LayoutOptions;

  constructor(
    public fieldsvc: FieldService,
    public fsvc: FormService,
  ) {
  }

  public getFieldsToLink() {
    return this.fsvc.form.form_fields.filter(f => f.field_type === 'dropdown' && f.field_id !== this.field.field_id);
  }
}
